import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {type IPerson} from '../schema';

/**
 * `updatePerson` request params
 * (what is used to send to server)
 */
export interface UpdatePersonRequestOptions {
	id: IPerson['id'];
	person: Pick<IPerson, 'name'>;
}

/**
 * `updatePerson` request
 * (what gets sent to the server)
 */
export type UpdatePersonRequest = [
	UpdatePersonRequestOptions['id'],
	UpdatePersonRequestOptions['person'],
];

/**
 * `updatePerson` response
 * (what comes back from the server)
 */
export type UpdatePersonResponse = SuccessResponse<UpdatePersonResult>;

/**
 * `updatePerson` result
 * (what is utilized from the server response)
 */
export type UpdatePersonResult = IPerson;

export const updatePersonEndpoint = 'updatePerson';

/**
 * Update person
 * @param fetchParams Fetch params
 * @returns Person
 */
export const updatePerson = async (
	{id, person}: UpdatePersonRequestOptions,
	signal?: AbortSignal,
): Promise<UpdatePersonResult> => {
	const client = NetxQueryClient();

	const requestParams: UpdatePersonRequest = [id, person];

	return client
		.post<UpdatePersonResponse>(updatePersonEndpoint, requestParams, {signal})
		.then(getResponseResults);
};

export default updatePerson;
